import { Link } from 'react-router'
import { UserPlus } from '@carouselgg/nexus/icon'
import { ActionLink } from '../../../components/ActionLink'
import styles from './home.module.css'

/**
 * Where a signed-in newcomer sees their trust score, a visitor sees how they
 * get one: the account, then the phone, which together reach the 20 a
 * competition needs.
 */
export function JoinPanel() {
  return (
    <section aria-labelledby="home-join" className={styles.section} data-panel="Your account">
      <div className={styles.sectionHead}>
        <h2 id="home-join" className={styles.sectionTitle}>Your account</h2>
      </div>
      <p className={styles.joinLead}>
        One verified profile for every game you play. Smurfs and cheaters can't start over with a fresh
        account, so every match is worth playing.
      </p>
      <ol className={styles.joinSteps}>
        <li><span className={styles.placeName}>Sign up</span><span className={styles.todoDesc}>Email, a username and your games.</span></li>
        <li><span className={styles.placeName}>Verify your phone</span><span className={styles.todoDesc}>Enough on its own to reach the trust score competitions ask for.</span></li>
        <li><span className={styles.placeName}>Link your game accounts</span><span className={styles.todoDesc}>Your rank, and stats from every match you play here.</span></li>
      </ol>
      <ActionLink to="/signup" className={styles.joinAction}>
        <UserPlus size={16} aria-hidden="true" /> Sign up free
      </ActionLink>
      <Link to="/login" className={styles.joinLogin}>Have an account? Log in</Link>
    </section>
  )
}
